import { API_CONFIG } from "./api";

const getToken = () => localStorage.getItem("token");
const BASE = API_CONFIG.BASE_URL;

const headers = () => ({
  Authorization: `Bearer ${getToken()}`,
  "Content-Type": "application/json",
});

export const notificationService = {
  getUnreadCount: async (userId) => {
    if (!getToken()) return { success: false };
    try {
      const res = await fetch(`${BASE}/firebase/unread-count/${userId}`, { headers: headers() });
      return await res.json();
    } catch { return { success: false, unreadCount: 0 }; }
  },

  getHistory: async (userId) => {
    if (!getToken()) return { success: false };
    try {
      const res = await fetch(`${BASE}/firebase/history/${userId}`, { headers: headers() });
      return await res.json();
    } catch { return { success: false, notifications: { unread: [], read: [] } }; }
  },

  markAsRead: async (userId, notificationIds) => {
    try {
      const res = await fetch(`${BASE}/firebase/mark-as-read`, {
        method: "POST", headers: headers(),
        body: JSON.stringify({ userId, notificationIds }),
      });
      return await res.json();
    } catch { return { success: false }; }
  },
};
